export const currentShoot = (shootId, myShootsArray) => {
  if (myShootsArray && shootId) {
    return myShootsArray.filter(x => x.id === Number(shootId))[0]
  } else {
    return {}
  }
}
